const routes = [
  {
    index: true,
    label: 'Simrith Ranjan',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  // {
  //   label: 'Blogs',
  //   path: '/blogs',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  // {
  //   label: 'Contact',
  //   path: '/contact',
  // },
];

export default routes;
